import { ArrowsMerge } from '@phosphor-icons/react';

export default ArrowsMerge;
